import dataApi from '../'

export default {

  /**
  * Get units that the given user is allowed to see
  */
  getEventsByUnit (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/event/events-by-unit',
      params: params
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/event.js